module.exports = __webpack_public_path__ + "f58e683a2c2dfacccda1fbe94e15d9c1.MP3";